// uncomment following line to turn on WhyDidYouRender hints
// import './wdyr';

// load all less style files (compiled to css by webpack)
import '../styles/dependencies.less';
import '../styles/app.less';

// add ES features polyfills - handled by @babel/env preset
import 'core-js';

// import Perf from 'react-addons-perf';
//
// window.Perf = Perf;

import {ThemeProvider} from '@mui/styles'; // NOTE: this is different from '@mui/material'
import {QueryClientProvider} from '@tanstack/react-query';
import {ReactQueryDevtools} from '@tanstack/react-query-devtools';
import {
  DatePickerLocaleProviderContainer,
  DlMuiDatePickerLocalizationProviderContainer,
  i18nContainer,
  loginContainer,
  utils,
  constants as datloweCoreConstants,
  ApiClient,
  QueryClientInstance,
  QueryClientContext,
  CoreApplicationDataLoader,
  DlMuiThemeProvider,
  ApplicationInfo,
} from '@wallaby-ui/core';
import {ApplicationDataLoader, constants as datloweDocumentConstants} from '@wallaby-ui/document';
import {constants as datloweLayoutConstants} from '@wallaby-ui/layout';
import {oneLineTrim} from 'common-tags';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import {Provider} from 'react-redux';
import {APPLICATION_NAME_HAIDI, LIBRARY_NAME} from 'src/js/common/constants';
import AppConfig from 'src/js/config/app_config';
import {AppDataConfig, CoreDataConfig} from 'src/js/config/app_data_config';
import keycloakConfig from 'src/js/config/common/keycloak_config.json';
import {theme, dlMuiCreateThemeFunction} from 'src/js/config/theme/theme';
import {LayoutContainer} from 'src/js/containers/layout/components';
import initializeKeycloak from 'src/js/keycloak';

import initializeStore from './store';

const {store, history} = initializeStore();

utils.LogUtils.toggleLogging(
  oneLineTrim`${datloweLayoutConstants.LIBRARY_NAME}*,
    ${datloweDocumentConstants.LIBRARY_NAME}*,
    ${datloweCoreConstants.LIBRARY_NAME}*,
    ${LIBRARY_NAME}*`
);

const keycloak = initializeKeycloak(keycloakConfig);

ApplicationInfo.setAppName(APPLICATION_NAME_HAIDI);
ApiClient.initApiClient('HAIDI', store, false);
ApiClient.initApiClient('HAIDI', store, true);
const client = QueryClientInstance.getClient(store, {
  defaultOptions: {
    queries: {
      staleTime: 30000,
    },
  },
});

const DynamicTranslationLoaderIds = CoreDataConfig.translations.map((item) => item.id ?? item.apiUrl);

ReactDOM.render(
  <Provider store={store}>
    <QueryClientProvider client={client} context={QueryClientContext}>
      <i18nContainer.IntlProviderContainer dynamicLoaders={DynamicTranslationLoaderIds}>
        <DlMuiThemeProvider theme={theme} dlMuiCreateThemeFunction={dlMuiCreateThemeFunction}>
          <ThemeProvider theme={theme}>
            <CoreApplicationDataLoader {...CoreDataConfig}>
              <loginContainer.ReactKeycloakProviderWrapper
                stateId={loginContainer.LOGIN_REDUCER_STATE_ID}
                config={AppConfig}
                keycloak={keycloak}
              >
                <ApplicationDataLoader appDataLoaders={AppDataConfig}>
                  <DlMuiDatePickerLocalizationProviderContainer>
                    <DatePickerLocaleProviderContainer>
                      <LayoutContainer config={AppConfig} history={history} />
                    </DatePickerLocaleProviderContainer>
                  </DlMuiDatePickerLocalizationProviderContainer>
                </ApplicationDataLoader>
              </loginContainer.ReactKeycloakProviderWrapper>
            </CoreApplicationDataLoader>
          </ThemeProvider>
        </DlMuiThemeProvider>
      </i18nContainer.IntlProviderContainer>
      <ReactQueryDevtools initialIsOpen={false} context={QueryClientContext} />
    </QueryClientProvider>
  </Provider>,
  document.getElementById('frontendApp')
);
